import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import Http from '../../../../Http';
import { FormControl, InputLabel, Select, MenuItem, TextField, InputAdornment, Button, IconButton, Icon, CircularProgress } from '@material-ui/core';
import './Convenios.css'
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { es } from 'date-fns/locale';

export const GrupoConvenios = (props) => {
  return (
    <div>
      <table>
        <thead>
          <tr>
            <td></td>
            <td>Origen</td>
            <td>Destino</td>
            <td>Cobro</td>
            <td>Embalaje</td>
            <td>Mínimo</td>
            <td>Máximo</td>
            <td>Precio</td>
            <td>Recolección</td>
            <td>Domicilio</td>
            <td>Inicio</td>
            <td>Fin</td>
          </tr>
        </thead>
        <tbody>
          {props.children}
        </tbody>
      </table>
    </div>
  )
}

export const Convenio = (props) => {
  return (
    <React.Fragment>
      <tr className={'tr-in'}>
        <td className={'td-remove'}>
          <IconButton onClick={() => { props.onRemove() }}>
            <Icon>remove_circle</Icon>
          </IconButton>
        </td>
        <td className='td-no'>
          <FormControl variant='outlined' style={{ minWidth: 100 }} fullWidth>
            <InputLabel>Origen</InputLabel>
            <Select
              value={props.convenio.id_origen}
              onChange={(e) => { props.onChange('id_origen', e.target.value) }}
            >
              {props.ops.origenes.map((op, oiv) => (
                <MenuItem value={op.id} key={oiv}>{op.sucursal}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </td>
        <td className='td-no'>
          <FormControl variant='outlined' style={{ minWidth: 100 }} fullWidth>
            <InputLabel>Destino</InputLabel>
            <Select
              value={props.convenio.id_destino}
              onChange={(e) => { props.onChange('id_destino', e.target.value) }}
            >
              {props.ops.origenes.map((op, oiv) => (
                <MenuItem value={op.id} key={oiv}>{op.sucursal}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </td>
        <td className='td-no'>
          <FormControl variant='outlined' style={{ minWidth: 100 }} fullWidth>
            <InputLabel>Cobro</InputLabel>
            <Select
              value={props.convenio.id_lista_precio_tipo}
              onChange={(e) => { props.onChange('id_lista_precio_tipo', e.target.value) }}
            >
              <MenuItem value={2} key={2}>Flete</MenuItem>
              <MenuItem value={3} key={3}>Entrega</MenuItem>
            </Select>
          </FormControl>
        </td>
        <td className='td-no'>
          <FormControl variant='outlined' style={{ minWidth: 100 }} fullWidth>
            <InputLabel>Embalaje</InputLabel>
            <Select
              value={props.convenio.id_embalaje}
              onChange={(e) => { props.onChange('id_embalaje', e.target.value) }}
            >
              {props.ops.embalajes.map((op, oiv) => (
                <MenuItem value={op.id} key={oiv}>{op.embalaje_nombre}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </td>
        <td className='td-no'>
          <FormControl style={{ minWidth: 50 }} fullWidth>
            <TextField type='number' variant='outlined' label='Mínimo' min="1" value={props.convenio.valor1} onChange={(e) => { props.onChange('valor1', e.target.value) }} />
          </FormControl>
        </td>
        <td className='td-no'>
          <FormControl style={{ minWidth: 50 }} fullWidth>
            <TextField type='number' variant='outlined' label='Máximo' min="1" value={props.convenio.valor2} onChange={(e) => { props.onChange('valor2', e.target.value) }} />
          </FormControl>
        </td>
        <td className='td-no'>
          <FormControl style={{ minWidth: 50 }} fullWidth>
            <TextField
              InputProps={{
                startAdornment: <InputAdornment position='start'>$</InputAdornment>,
              }}
              variant='outlined' label='Precio' value={props.convenio.valor} onChange={(e) => { props.onChange('valor', e.target.value) }} />
          </FormControl>
        </td>
        <td className='td-no'>
          <FormControl variant='outlined' style={{ minWidth: 100 }} fullWidth>
            {/* <InputLabel>Embalaje</InputLabel> */}
            <Select
              value={props.convenio.recoleccion}
              onChange={(e) => { props.onChange('recoleccion', e.target.value) }}
            >
              <MenuItem value={1}>Sí</MenuItem>
              <MenuItem value={2}>No (hasta la zona limite)</MenuItem>
              <MenuItem value={3}>Nunca</MenuItem>
            </Select>
          </FormControl>
        </td>
        <td className='td-no'>
          <FormControl variant='outlined' style={{ minWidth: 100 }} fullWidth>
            {/* <InputLabel>Embalaje</InputLabel> */}
            <Select
              value={props.convenio.domicilio}
              onChange={(e) => { props.onChange('domicilio', e.target.value) }}
            >
              <MenuItem value={1}>Sí</MenuItem>
              <MenuItem value={2}>No (hasta la zona limite)</MenuItem>
              <MenuItem value={3}>Nunca</MenuItem>
            </Select>
          </FormControl>
        </td>
        <td className='td-no' style={{minWidth: 200}}>
          <MuiPickersUtilsProvider utils={DateFnsUtils} locale={es}>
            <KeyboardDatePicker
              autoOk
              fullWidth
              // variant='inline'
              inputVariant="outlined"
              clearable
              value={props.convenio.fecha_inicio}
              onChange={date => props.onChange('fecha_inicio', date)}
              format="dd/MM/yyyy"
            />
          </MuiPickersUtilsProvider>
        </td>
        <td className='td-no' style={{minWidth: 200}}>
          <MuiPickersUtilsProvider utils={DateFnsUtils} locale={es}>
            <KeyboardDatePicker
              autoOk
              fullWidth
              // variant='inline'
              inputVariant="outlined"
              clearable
              value={props.convenio.fecha_termino}
              onChange={date => props.onChange('fecha_termino', date)}
              format="dd/MM/yyyy"
            />
          </MuiPickersUtilsProvider>
        </td>
      </tr>
    </React.Fragment>
  )
}


class Convenios extends Component {

  state = {
    ops: {
      origenes: [],
      destinos: [],
      embalajes: [],
      tipos_condicion: [],
      tipos_listas: [],
    },
    loading: false,
    convenios: [
      // { id_origen: 2, id_destino: 3, id_embalaje: 4, valor1: 0, valor2: 0, valor: 0, recoleccion: 1, domicilio: 2 },
      // { id_origen: 2, id_destino: 3, id_embalaje: 4, valor1: 0, valor2: 0, valor: 0, recoleccion: 1, domicilio: 2 }
    ],
  }

  componentDidMount() {
    this.loadFormData();
  }

  loadConvenios = async () => {
    var Res = await Http.get(`cliente/${this.props.match.params.id}/convenio`);
    if (!Res.error) {
      this.setState({ convenios: Res.data.convenios })
    }
  }

  loadFormData = async (form) => {
    var Res = await Http.get('lista-precio/lp');
    console.log(Res.data);
    if (!Res.error) {
      this.setState({ ops: { ...this.state.ops, ...Res.data } })
    }
    this.loadConvenios();

  }

  guardarConvenio = async () => {
    this.setState({ loading: true })
    var Res = await Http.post(`cliente/${this.props.match.params.id}/convenio/save`, { convenios: this.state.convenios });
    if (!Res.error) {
      this.loadConvenios();
    }
    this.setState({ loading: false })
  }

  agregarConvenio = () => {
    this.setState((state) => {
      state.convenios.push({ id_origen: 1, id_destino: 6, id_embalaje: 4, valor1: 0, valor2: 0, valor: 0, recoleccion: 1, domicilio: 2, fecha_inicio: new Date(), fecha_termino: new Date(), id_lista_precio_tipo: 2 });
      return { convenios: state.convenios }
    })
  }

  convenioChange = (i, prop, val) => {
    this.setState((state) => {
      state.convenios[i][prop] = val;
      return { convenios: state.convenios }
    })
  }

  convenioRemove = async (convenio) => {
    console.log(convenio)
    var Res = await Http.post(`cliente/${this.props.match.params.id}/convenio/delete`, { convenio });
    console.log(Res)
    if (!Res.error) {
      this.loadConvenios();
    }
  }

  render() {
    const { ops, convenios, loading } = this.state;
    return (
      <div style={{ padding: 20 }}>
        <div style={{ textAlign: 'right' }}>
          <Button onClick={() => this.agregarConvenio()} variant='outlined'>Agregar</Button>
        </div>
        <div style={{ overflowX: 'scroll' }} className='scroll-css'>
          <GrupoConvenios>
            {
              convenios.map((convenio, ci) => (
                <Convenio
                  key={ci}
                  ops={ops}
                  convenio={convenio}
                  onChange={(prop, val) => this.convenioChange(ci, prop, val)}
                  onRemove={() => this.convenioRemove(convenio)}
                />
              ))
            }
          </GrupoConvenios>
        </div>
        <div style={{ textAlign: 'right', paddingTop: 10 }}>
          <Button onClick={this.guardarConvenio} variant='contained' disabled={loading} >
            { loading &&
              <CircularProgress color="secondary" size={20} />
            }
            Guardar
          </Button>
        </div>
      </div>
    )
  }
}

export default withRouter(Convenios)
